<template>
    <div :class="outerInputStyle">
        <vue-numeric
            v-if="editable"
            :class="['form-control', inputStyle]"
            :currency="''"
            :min="min"
            :minus="meta.sign"
            :precision="meta.decimal"
            :field="id"
            v-model="amount"
        ></vue-numeric>
        <span v-else>{{ formattedNumber }}</span>
    </div>
</template>

<script>
import Vue from "vue";
import VueNumeric from "vue-numeric";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

export default {
    props: {
        meta: {
            type: Object,
            default: () => ({}),
        },
        editable: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 0,
        },
        eager: {
            type: Boolean,
            default: false,
        },
        inputStyle: {
            type: String,
            default: "",
        },
        outerInputStyle: {
            default: function () {
                return [
                    this.id.replace("_", "-"),
                    "currency-cell",
                    {
                        positive: this.positive,
                        negative: this.negative,
                    },
                ];
            },
        },
    },

    components: {
        VueNumeric,
    },

    computed: {
        amount: {
            get() {
                return this.parseNumber(this.value);
            },
            set(newValue) {
                this.changedValue(newValue);
            },
        },
        formattedNumber: function () {
            return this.parseNumber(this.value);
        },
        positive: function () {
            return this.meta.sign && this.value > 0;
        },
        negative: function () {
            return this.meta.sign && this.value < 0;
        },
        min: function () {
            return this.meta.non_negative ? 0 : Number.MIN_SAFE_INTEGER;
        },
    },

    methods: {
        parseNumber(value) {
            if (typeof value !== "number") {
                return "";
            }
            return this.getFormatedNumber(value, this.meta);
        },

        getFormatedNumber(value, meta) {
            let num = value
                .toFixed(meta.decimal)
                .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

            if (meta.sign && value > 0) {
                num = "+" + num;
            }

            return num;
        },

        changedValue(value) {
            if (this.eager || this.value !== value) {
                this.$emit("change", value);
            }
        },
    },
};
</script>